import React from 'react'
import { SvgIconProps } from './Home'

const SvgEventsIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "18"}
    height={height ?? "18"}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill={fill ?? "#353535"}
      d="M15.158 1.421h-.947V0H12.316V1.421H5.684V0H3.79V1.421h-.947C1.232 1.421 0 2.653 0 4.168v11.085C0 16.768 1.232 18 2.842 18h12.316C16.768 18 18 16.768 18 15.253V4.168c0-1.515-1.232-2.747-2.842-2.747zm.947 5.495v8.242a.95.95 0 01-.947.947H2.842c-.568 0-.947-.379-.947-.947V6.916h14.21zM4.263 4.168H5.684v-.947h6.632v.947H14.21v-.947h.948c.568 0 .947.379.947.947v.948H1.895v-.948a.95.95 0 01.947-.947h.947v.947h.474z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M6.726 12.41l-.094 1.327c0 .284.094.568.379.758.189.095.284.19.473.19.095 0 .284 0 .38-.095L9 14.02l1.137.569c.095.094.19.094.379.094.19 0 .379-.094.473-.19.285-.189.38-.473.38-.757l-.095-1.326.852-1.043c.19-.189.285-.568.19-.852-.095-.284-.284-.474-.663-.569l-1.232-.284-.663-1.137c-.095-.094-.19-.284-.284-.284-.19-.19-.285-.19-.474-.19-.284 0-.568.19-.758.474L7.58 9.663l-1.232.284c-.284.095-.568.285-.663.569-.095.284 0 .568.19.852l.852 1.043z"
    ></path>
  </svg>
)


export default SvgEventsIcon